import imageContentCarousel from './image-content-carousel';
export default imageContentCarousel;
